import EventEmitter from '../lib/helpers/EventEmmiter';

require('./pannellum-controls-player-slider.less');

export default class E3PlayerSlider extends EventEmitter{
    constructor(container, options = {}){
        super();
        this._options = options;
        this._container = container;
        this._init();
    }

    addClass(className) {
        if(!this._wrapper) return;
        this._wrapper.classList.add(className);
    }

    setValue(position) {
        position = Math.max(position, 0);
        position = Math.min(position, 1);
        this._past.style.width = position * 100 + '%';
        if(this._options.withTooltip) {
            this._setTooltipValue(position);
        }
        return position;
    }

    getValue() {
        return parseFloat(this._past.style.width || 0) / 100;
    }

    setBuffer(percent) {
        if(!this._buffer) return;
        this._buffer.style.width = percent * 100 + '%';
    }

    animateTo(position, animationTime){
        this._wrapper.classList.add('animating');

        this._past.style.transitionDuration = (animationTime || 0) + 's';
        this._past.style.width = position * 100 + '%';
    }

    stopAnimating(pos) {
        var position = typeof pos === 'number' ? pos : parseFloat(getComputedStyle(this._past).width) / parseFloat(getComputedStyle(this._line).width);
        if(this._wrapper.classList.contains('animating')) {
            this._wrapper.classList.remove('animating');
            this._past.style.transitionDuration = '0s';
            this._past.style.width = position * 100 + '%';
        }
        return position;
    }

    _init() {
        var wrapper = document.createElement('div');
        wrapper.classList.add('e3-slider');
        this._wrapper = wrapper;
        this._container.appendChild(wrapper);

        var line = document.createElement('div');
        line.classList.add('e3-slider-line');
        this._line = line;
        wrapper.appendChild(line);

        var buffer = document.createElement('div');
        buffer.classList.add('e3-slider-line-buffer');
        this._buffer = buffer;
        line.appendChild(buffer);

        var past = document.createElement('div');
        past.classList.add('e3-slider-line-past');
        this._past = past;
        line.appendChild(past);

        var point = document.createElement('span');
        point.classList.add('e3-slider-line-past-point');
        this._point = point;
        past.appendChild(point);

        this._callbacks = {
            mousedown: this._onSliderMouseDown.bind(this),
            mouseup: this._onSliderMouseUp.bind(this),
            mousemove: this._onSliderMouseMove.bind(this),
        };

        wrapper.addEventListener('mousedown', this._callbacks.mousedown);
        wrapper.addEventListener('touchstart', this._callbacks.mousedown);

        if(this._options.withTooltip) {
            var tooltip = document.createElement('span');
            tooltip.classList.add('e3-slider-tooltip');
            this._tooltip = tooltip;
            wrapper.appendChild(tooltip);
            this._callbacks.tooltip = this._onSliderMouseMoveTooltip.bind(this);
            wrapper.addEventListener('mousemove', this._callbacks.tooltip);
            wrapper.addEventListener('touchmove', this._callbacks.tooltip);
        }
    }

    _setTooltipValue(percent) {
        this._tooltip.innerHTML = (this._options.tooltipContentFunc || function(percent){return percent * 100 + '%';})(percent);
        this._tooltip.style.left = percent * 100 + '%';
    }

    _onSliderMouseDown(e) {
        e.preventDefault();
        e = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]) || e;
        this._wrapper.classList.add('moving');
        var lineStart = this._line.getBoundingClientRect().left;
        var point = this._point.getBoundingClientRect();
        this._xStart = lineStart + (e.target === this._point ? e.pageX - point.left - point.width / 2 : 0);
        var position = (e.pageX - this._xStart) / this._line.clientWidth;
        position = this.setValue(position);

        document.addEventListener('mousemove', this._callbacks.mousemove);
        document.addEventListener('touchmove', this._callbacks.mousemove);
        document.addEventListener('mouseup', this._callbacks.mouseup);
        document.addEventListener('touchend', this._callbacks.mouseup);
        this._wrapper.removeEventListener('mousedown', this._callbacks.mousedown);
        this._wrapper.removeEventListener('touchstart', this._callbacks.mousedown);
        this._fireEvent('change.start', position);
        this._fireEvent('change', position);
    }

    _onSliderMouseMove(e) {
        e.preventDefault();
        e = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]) || e;
        var position = (e.pageX - this._xStart) / this._line.clientWidth;
        position = this.setValue(position);
        this._fireEvent('change', position);
    }

    _onSliderMouseUp(e) {
        e.preventDefault();
        e = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]) || e;
        var position = (e.pageX - this._xStart) / this._line.clientWidth;
        position = this.setValue(position);
        document.removeEventListener('mousemove', this._callbacks.mousemove);
        document.removeEventListener('touchmove', this._callbacks.mousemove);
        document.removeEventListener('mouseup', this._callbacks.mouseup);
        document.removeEventListener('touchend', this._callbacks.mouseup);
        this._wrapper.addEventListener('mousedown', this._callbacks.mousedown);
        this._wrapper.addEventListener('touchstart', this._callbacks.mousedown);
        delete this._xStart;
        this._wrapper.classList.remove('moving');
        this._fireEvent('change', position);
        this._fireEvent('change.end', position);
    }

    _onSliderMouseMoveTooltip(e) {
        if(!this._options.withTooltip) return;
        e = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]) || e;
        var left = this._line.getBoundingClientRect().left;
        var position = e.target === this._point ? parseFloat(this._past.style.width || 0) / 100 : (e.pageX - left) / this._wrapper.clientWidth;
        position = Math.max(position, 0);
        position = Math.min(position, 1);
        this._setTooltipValue(position);
    }
}
